// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"styles_ContentWrapper__21aQV","PreloaderWrapper":"styles_PreloaderWrapper__2wfcw"};